module.exports = __webpack_public_path__ + "img/part2-dIcon4.bb214dd2.png";